export const JSON_MODAL_PRIMARY_DOCUMENT_TITLE = 'Grid Row';
export const JSON_MODAL_PAYLOAD_KIND = 'json-modal' as const;

/** One Show JSON tab. Producers always set `title`. */
export type JsonModalDocument = {
  id: string;
  title: string;
  value: unknown;
  /** Shown when `value` is null or undefined instead of JSON null. */
  emptyMessage?: string;
};

export function gridRowDocument(value: unknown): JsonModalDocument {
  return { id: 'row', title: JSON_MODAL_PRIMARY_DOCUMENT_TITLE, value };
}

export type JsonModalPayload = {
  kind: typeof JSON_MODAL_PAYLOAD_KIND;
  documents: [JsonModalDocument, ...JsonModalDocument[]];
};

export type JsonModalResolvedDocument = {
  id: string;
  title: string;
  content: string;
};
